export default "__VITE_ASSET__D_V9MHor__"